import './SelectLoader.css';
import React from 'react';
import { cn } from '../../../utils/bem';
import { Loader } from '../../Loader/Loader';
import { defaultPropSize } from '../types';
export var cnSelectLoader = cn('SelectLoader');
export var SelectLoader = function (props) {
    var _a = props.mode, mode = _a === void 0 ? 'empty' : _a, _b = props.size, size = _b === void 0 ? defaultPropSize : _b;
    return (React.createElement("div", { className: cnSelectLoader({ mode: mode, size: size }) },
        React.createElement(Loader, { className: cnSelectLoader('Loader'), size: "s" })));
};
